import { Injectable } from '@angular/core'
import { Action, Selector, State, StateContext } from '@ngxs/store'
import { tap } from 'rxjs/operators'
import { PageStateModel } from './page.model'
import { PageService } from '../page.service'
import {
  GetPublicResources,
  GetPublicResourcesPage,
  GetWhoToCallPage,
  ResetPageData,
  UpdatePublicResourcesPage,
  UpdateWhoToCallPage,
  UploadPublicResources
} from './page.actions'

@State<PageStateModel>({
  name: 'page'
})
@Injectable()
export class PageState {
  whoToCallType = 'WhoToCall'
  publicResourcesType = 'PublicResources'

  constructor(private pageService: PageService) {}

  @Selector()
  static pageData(state: PageStateModel) {
    return state.pageData
  }

  @Selector()
  static publicResources(state: PageStateModel) {
    return state.publicResources
  }

  @Action(ResetPageData)
  resetPageData(ctx: StateContext<PageStateModel>) {
    ctx.patchState({
      pageData: undefined
    })
  }

  @Action(GetWhoToCallPage)
  getWhoToCallPage(ctx: StateContext<PageStateModel>) {
    ctx.patchState({
      pageData: undefined
    })
    return this.pageService.getPageData(this.whoToCallType).pipe(
      tap((res) => {
        ctx.patchState({
          pageData: res
        })
      })
    )
  }

  @Action(UpdateWhoToCallPage)
  updateWhoToCallPage(ctx: StateContext<PageStateModel>, { payload }: UpdateWhoToCallPage) {
    return this.pageService.updatePageData({
      ...payload,
      type: this.whoToCallType,
      title: 'Who to Call'
    })
  }

  @Action(GetPublicResourcesPage)
  getPublicResourcesPage(ctx: StateContext<PageStateModel>) {
    ctx.patchState({
      pageData: undefined
    })
    return this.pageService.getPageData(this.publicResourcesType).pipe(
      tap((res) => {
        ctx.patchState({
          pageData: res
        })
      })
    )
  }

  @Action(UpdatePublicResourcesPage)
  updatePublicResourcesPage(ctx: StateContext<PageStateModel>, { payload }: UpdatePublicResourcesPage) {
    return this.pageService.updatePageData({
      ...payload,
      type: this.publicResourcesType,
      title: 'Public Resources'
    })
  }

  @Action(UploadPublicResources)
  uploadPublicResources(ctx: StateContext<PageStateModel>, { files }: UploadPublicResources) {
    return this.pageService.uploadPublicResource(files)
  }

  @Action(GetPublicResources)
  getPublicResources(ctx: StateContext<PageStateModel>) {
    return this.pageService.getPublicResources().pipe(
      tap((res) => {
        ctx.patchState({
          publicResources: res ?? []
        })
      })
    )
  }
}
